function currentSiteHost() {
  if (typeof window === "undefined" || !window.location?.hostname) return "amigoearuba.com";
  return window.location.hostname.replace(/^live\./, "").replace(/^www\./, "");
}

function liveGatewayBase() {
  if (typeof window === "undefined" || !window.location?.protocol) return "https://live-gateway.amigoearuba.com";
  return `${window.location.protocol}//live-gateway.${currentSiteHost()}`;
}

function rootSiteBase() {
  if (typeof window === "undefined" || !window.location?.protocol) return "https://amigoearuba.com";
  return `${window.location.protocol}//${currentSiteHost()}`;
}

function livePageUrl() {
  return `${rootSiteBase()}/live/`;
}

export const config = {
  region: import.meta.env.VITE_AWS_REGION ?? "us-east-1",
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
  gatewayUrl: import.meta.env.VITE_GATEWAY_URL as string,
  archiveFeedUrl: import.meta.env.VITE_ARCHIVE_FEED_URL ?? `${rootSiteBase()}/wp-admin/admin-ajax.php?action=amigoe_live_archive_feed`,
  trackerUrl: import.meta.env.VITE_TRACKER_URL ?? `${rootSiteBase()}/wp-admin/admin-ajax.php?action=amigoe_live_track`,
  hlsUrl: import.meta.env.VITE_MEDIAPACKAGE_HLS_URL as string,
  relayHlsUrl: import.meta.env.VITE_RELAY_HLS_URL ?? "/relay-hls/liveprimary/index.m3u8",
  archiveBucketUrl: import.meta.env.VITE_ARCHIVE_BUCKET_URL as string,
  emergencySupportUrl: import.meta.env.VITE_EMERGENCY_SUPPORT_URL as string | undefined,
  channelPlaylistUrl: import.meta.env.VITE_CHANNEL_PLAYLIST_URL ?? `${liveGatewayBase()}/wordpress-playlist.json`,
  liveStatusUrl: import.meta.env.VITE_LIVE_STATUS_URL ?? `${liveGatewayBase()}/streams/active`,
  bannerUrl: import.meta.env.VITE_BANNER_URL ?? `${liveGatewayBase()}/banner.json?placement=below`,
  livePageUrl: import.meta.env.VITE_LIVE_PAGE_URL ?? livePageUrl(),
};

for (const [k, v] of Object.entries(config)) {
  if (!v) console.warn(`[config] missing env var for "${k}"`);
}
